import { ResourceCard } from './resource-card';
import type { CardProps } from './types';

/** Embed block tile. */
export const EmbedCard = ({ block, onClick }: CardProps) => (
  <ResourceCard block={block} onClick={onClick} caption={block.title || 'Embed'} bannerUrl={block.textBannerUrl} />
);
